import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {
  UserProperty,
  CacheConstant,
  CacheDuration
} from '../../../../core/constants/app.constant';
import { AppUtilService } from '../../../../core/utils/app-util.service';
@Component({
  selector: 'par-favourites-confirmation',
  templateUrl: './favourites-confirmation.component.html',
  styleUrls: ['./favourites-confirmation.component.scss']
})
export class FavouritesConfirmationComponent implements OnInit {

  duplicateProduct: boolean;
/***************Constructor***************/
  constructor(
    public dialogRef: MatDialogRef<FavouritesConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.duplicateProduct = this.data.duplicateProducts ? this.data.duplicateProducts.length > 0 : false;
  }
/***************Constructor***************/

  /***************Component Methods***************/

  onClose() {
    this.dialogRef.close(true);
  }
  redirectTofavList() {
    AppUtilService.cache.set(
      CacheConstant.Favourite_List_Data,
      this.data.favList,
      CacheDuration.OneMinute
    );
    this.dialogRef.close(false);
    AppUtilService.router.navigate(['/product/favorites']);
  }
  /***************Component Methods***************/
}
